<template>
  <Icon
    v-if="iconData"
    v-bind="$attrs"
    class="app-icon"
    :icon="iconData"
  />
  <span
    v-else
    v-bind="$attrs"
    class="app-icon app-icon--placeholder"
  />
</template>

<script>
import { Icon } from '@iconify/vue/offline'
import { DEFAULT_GENERIC_ICON, resolveIconData } from '@/utils/iconCatalog.mjs'

export default {
  name: 'AppIcon',
  components: { Icon },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: '',
    },
    fallback: {
      type: String,
      default: DEFAULT_GENERIC_ICON,
    },
  },
  data() {
    return {
      iconData: null,
      resolveSequence: 0,
    }
  },
  watch: {
    name: {
      immediate: true,
      handler: 'refreshIconData',
    },
    fallback: 'refreshIconData',
  },
  methods: {
    async refreshIconData() {
      const sequence = ++this.resolveSequence
      try {
        const iconData = await resolveIconData(this.name, this.fallback)
        if (sequence === this.resolveSequence) {
          this.iconData = iconData
        }
      } catch (error) {
        if (sequence === this.resolveSequence) {
          this.iconData = null
          this.$emit('load-error', error)
        }
      }
    },
  },
}
</script>

<style scoped>
.app-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
  flex: 0 0 auto;
  line-height: 1;
  vertical-align: -0.125em;
}

.app-icon--placeholder {
  visibility: hidden;
}
</style>
